import * as React from "react";
import QRCode from "qrcode.react";
import { parseUrl } from "query-string";
import ValidationErrors from "~/lib/ValidationErrors";
import Panel from "~/components/shared/Panel";
import Button from "~/components/shared/Button";
import TokenCodeInput from "~/components/shared/TokenCodeInput";
import buildkiteqr from "~/components/user/TwoFactor/TwoFactorConfigure/TwoFactorConfigureActivate/buildkite.svg";

type ValidationError = {
  field: string;
  message: string;
};

type Props = {
  onActivateOtp: (token: string, callback?: () => void) => void;
  provisioningUri: string;
};

type State = {
  errors: Array<ValidationError> | null | undefined;
  isActivating: boolean;
  totpCodeValue: string;
  copiedOTPSecretKey: boolean;
};

export default class TwoFactorConfigureActivate extends React.PureComponent<Props, State> {
  tokenInputRef = React.createRef<TokenCodeInput>();

  state = {
    errors: [],
    isActivating: false,
    totpCodeValue: "",
    copiedOTPSecretKey: false,
  };

  render() {
    const errors = new ValidationErrors(this.state.errors);
    const provisioningUriSecret = parseUrl(this.props.provisioningUri).query.secret;

    return (
      <>
        <p>
          To activate two-factor authentication, scan this barcode with your authenticator
          application, then enter the generated One Time Password below.
        </p>
        <Panel className="mb-3">
          <div className="flex items-center justify-center">
            <div className="mb-3 mt-1">
              <figure
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img style={{ position: "absolute", width: 102, marginTop: 6 }} src={buildkiteqr} />
                <QRCode
                  renderAs="svg"
                  fgColor="currentColor"
                  bgColor="transparent"
                  width="260"
                  height="260"
                  className="mx-auto block"
                  level="H" // approx 30% error correction
                  style={{ maxWidth: "100%" }}
                  value={this.props.provisioningUri}
                />
              </figure>
              <div className="dark-gray mt-2 text-center">
                Can’t use the barcode?
                <br />
                You can use this secret key instead:{" "}
                <span
                  className="monospace rounded"
                  style={{ fontSize: 13 }}
                  aria-label="Secret Key"
                >
                  {provisioningUriSecret}
                </span>
              </div>
            </div>
          </div>
        </Panel>
        <div className="mb-3 py-4">
          <TokenCodeInput
            ref={this.tokenInputRef}
            errors={errors.findForField("token")}
            disabled={this.state.isActivating}
            value={this.state.totpCodeValue}
            onChange={this.handleTotpCodeChange}
          />
        </div>
        <Button
          className="w-full"
          disabled={this.state.isActivating}
          theme="primary"
          onClick={this.handleTotpActivate}
        >
          Activate
        </Button>
      </>
    );
  }

  handleTotpCodeChange = (totpCodeValue: string) => {
    this.setState({ totpCodeValue });
  };

  handleTotpActivate = () => {
    this.setState({ isActivating: true }, () => {
      // @ts-expect-error - TS2345 - Argument of type '(errors: any) => void' is not assignable to parameter of type '() => void'.
      this.props.onActivateOtp(this.state.totpCodeValue, (errors) => {
        if (errors) {
          this.setState({ errors, isActivating: false }, () => {
            if (this.tokenInputRef.current) {
              // $FlowExpectError Typing createRefs seems broken at the moment, hopefully we can fis this at some point.
              this.tokenInputRef.current.focus();
            }
          });
        } else {
          this.setState({ errors: [], isActivating: false });
        }
      });
    });
  };
}
